import {Segment} from 'semantic-ui-react';
import ExamReportForm from './form';
import {fetchRemainStudentCoursesToCreateExamReport} from '../../redux/actions/student-course';
import Fetcher from '../shared/fetches/fetcher';

function ExamReportContainer() {
  return (
    <Segment>
      <Fetcher
        action={fetchRemainStudentCoursesToCreateExamReport}
        stateSelector={state => state.remainStudentCourses}
      >
        {remainStudentCourses => (<ExamReportForm remainStudentCourses={remainStudentCourses}/>)}
      </Fetcher>
    </Segment>
  );
}

export default ExamReportContainer;
